import { useLocale } from '@/context/LocaleContext';
import { getLanguageFromLocale } from '@/utilities/getLanguageFromLocale';

export const useLanguage = () => {
  const { locale } = useLocale();
  const language = getLanguageFromLocale(locale);
  if (!language) {
    throw new Error(`Unsupported locale: ${locale}`);
  }

  return language;
};
